import { StreamActions } from '@hotwired/turbo'

StreamActions.dispatch_event = function() {
  const type = this.getAttribute('type')
  const detail = JSON.parse(this.getAttribute('detail') || '{}')

  if (type) {
    document.dispatchEvent(new CustomEvent(type, { detail }))
  }
}
